// Copyright © 2017-2019  SDG Systems, LLC. All rights reserved.
// This file may not be used in any form without the express written permission of SDG Systems, LLC.

<template>
  <img
    v-if="variant === 'drawer'"
    :src="src"
    :alt="alt"
    class="app-logo app-logo--drawer"
  >
  <v-img
    v-else
    :src="src"
    :alt="alt"
    contain
    :aspect-ratio="aspectRatio"
    class="app-logo app-logo--login my-12"
  />
</template>

<script>
export default {
  name: 'AppLogo',

  props: {
    variant: {
      type: String,
      default: 'drawer',
      validator: (v) => ['drawer', 'login'].includes(v)
    },
    src: {
      type: String,
      default: 'static/logo.svg'
    },
    alt: {
      type: String,
      default: ''
    },
    aspectRatio: {
      type: Number,
      default: 7.696
    }
  },

  created () {
    const subdomain = window.location.host.split('.')[0]
    if (subdomain === 'mbility') {
      this.src = 'static/mbility-logo.png'
    }
    console.log(this.src)
  }
}
</script>

<style scoped>
.app-logo--drawer {
  width: 100%;
  padding-top: 8px;
}

.app-logo--login {
  width: 75%;
  background-color: white;
  margin-right: auto;
  margin-left: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/AppLogo.vue